<template>
  <v-card tile class="pt-0" :class="$vuetify.breakpoint.smAndDown ? 'rounded-b' : 'rounded-br'" height="100%">
    <v-card-title v-if="$vuetify.breakpoint.smAndDown" class="pa-4 primary white--text">
      <h3>Sidebar Content</h3>
    </v-card-title>
    <v-card-text>
      <slot/>
      <tags :editable="editable"></tags>
      <roles :editable="editable"></roles>
    </v-card-text>
  </v-card>
</template>

<script>
import 'codemirror/lib/codemirror.css'
import '@toast-ui/editor/dist/toastui-editor.css'
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import Tags from './Tags'
import Roles from './Roles'
export default {
  components: {
    Tags,
    Roles
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
</style>
